import { render } from "./PreavvisiSospSolleciti.vue?vue&type=template&id=4667fe58"
import script from "./PreavvisiSospSolleciti.vue?vue&type=script&lang=js"
export * from "./PreavvisiSospSolleciti.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__